import { render, staticRenderFns } from "./DCConfirmDeliveryView.vue?vue&type=template&id=03382848&"
import script from "./DCConfirmDeliveryView.vue?vue&type=script&lang=js&"
export * from "./DCConfirmDeliveryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports